export default {
  signup: {
    left: {
      header: {
        feature: "Welcome to Dataships",
        heading: "Get started for free in 5 minutes",
        description:
          "Grow your email lists by optimizing your marketing compliance at the checkout.",
      },
      getStarted: {
        title:
          "Before you begin, kindly make sure you have the following list:",
        item1: "Klaviyo access to create a private API key",
        item2: "The URL of your current privacy policy",
        item3: "Access to your Shopify store to edit Checkout settings",
      },
    },
    right: {
      header: {
        feature: "Sign up",
        heading: "Create your account",
      },
      orSignUp: "or sign up with email",
      inputLabel: "Shopify Store",
      form: {
        email: {
          label: "Email Address",
          placeholder: "Insert your company email address",
          errors: {
            empty: "You must supply an email address.",
            workEmail: "You must supply a valid work email address.",
          },
        },
        password: {
          label: "Password",
          placeholder: "Choose your password",
          helper: "Use at least 10 characters",
          errors: {
            empty: "You must supply a password.",
            requirements: "Password is invalid (minimum is 10 characters)",
          },
        },
        firstName: {
          label: "First Name",
          empty: "You must supply your first name",
          placeholder: "Insert your first name",
        },
        lastName: {
          label: "Last Name",
          empty: "You must supply your last name",
          placeholder: "Insert your last name",
        },
        checkboxes: {
          marketingConsent:
            "Keep me up to date with news and new product information",
        },
        buttons: {
          cta: "Continue with email",
          agree:
            "By creating an account you are agreeing to Dataships <1>Terms of Use</1> and <3>Privacy Practices</3>.",
          secondary: "Already have an account?",
        },
        emailError: "Please check your email for a message from Dataships.",
      },
    },
    modal: {
      fetching: "Fetching store information from Shopify, please wait...",
      failed: "Unable to fetch store information, redirecting to Shopify...",
    },
  },
  profile: {
    heading: "Go to our App Listing to install on your new store",
    description:
      "Click below to go straight to our app listing or we'll redirect you after {{seconds}} seconds",
    cta: "Let's go",
  },

  privacyPolicyUrl: {
    left: {
      header: {
        feature: "Step 3",
        heading: "Where is your Privacy Policy published?",
        description:
          "Enter the <1>URL</1> where your <3>Privacy Policy</3> is located on your website.",
      },
    },
    right: {
      input: {
        label: "URL",
        required: "Privacy URL is required",
        invalid: "A valid URL is required",
      },
      submit: "Submit",
    },
    center: {
      title: "Attention",
      description_1:
        "It is your responsibility to ensure that your Privacy Policy is up to date and covers applicable data privacy regulations.",
      description_2:
        "If you have any queries or concerns you would like our assistance with, please click <1>Help</1> to book a meeting with one of our data privacy experts.",
    },
    successNotification: "Privacy Policy URL saved successfully.",
  },

  privacyEmail: {
    left: {
      header: {
        feature: "Step 4",
        heading: "Where can you be contacted for privacy queries?",
        description:
          "Enter the <1>email address</1> that customers can use to contact you if they have data privacy questions.",
      },
    },
    right: {
      input: {
        label: "Email",
        placeholder: "Email",
        required: "Privacy email is required",
        invalid: "This is not a valid email address.",
      },
      submit: "Submit",
    },
    successNotification: "Privacy email saved successfully.",
  },

  klaviyoApiKey: {
    left: {
      header: {
        feature: "Step 1",
        heading: "Create a Private API Key in Klaviyo",
        description: {
          step1:
            "Click <1>here</1> to sign into Klaviyo to create a Private API Key",
          step2: "Name the API Key e.g. <1>Dataships</1>",
          step3:
            "Click the <1>Grant applications full access for every API scope</1>",
          step4: "Click <1>Create</1>",
          step5:
            "Your Private Key will be displayed. Click the <1>Copy</1> button to copy it to your clipboard",
          step6:
            "Return to this screen and paste it in the API Key box and click <1>Submit</1>",
        },
      },
    },
    right: {
      input: {
        label: "API Key",
        invalidPrivateKey: "Invalid API key, please try again.",
        blankPrivateKey: "API key cannot be blank",
      },
      klaviyoOrganization: "Klaviyo Organization",
      klaviyoOrganizationError: "Unable to verify API Key",
      cta: "Submit",
    },
    invalidApiKey: "The API Key you entered is invalid, please try again.",
  },
  klaviyoOptIn: {
    left: {
      header: {
        feature: "Step 2",
        heading: "Change your List Opt-in Settings in Klaviyo",
        description: {
          step1:
            "Navigate to your newly created 'Dataships Marketable Email (Single Opt In)' <1>List<1>",
          step2: "Select <1>Consent</1>",
          step3: "Under <1>Opt-in Process</1>, select <3>Single Opt-in</3>",
          step4: "Click <1>Save</1>",
          step5: "Return to this screen and click <1>Continue</1>",
        },
      },
      accordions: {
        newDatashipsLists: {
          title:
            "What Klaviyo list(s) will my contacts be sent to by Dataships?",
          content:
            "We have created two new lists in your Klaviyo that your contacts will be sent to. By default these are 'Dataships Marketable Email (Single Opt In)' and 'Dataships Marketable Email (Double Opt In)'. If you have existing single opt-in or double opt-in enabled lists that you would like to use instead, you can change this after onboarding in the Control Panel (Integration Settings > Klaviyo Lists).",
        },
        twoTypes: {
          title:
            "Why do I need one single opt-in list and one double opt-in list, can't I just use one list?",
          content:
            "This is due to a combination of how email marketing laws differ by country and how Klaviyo list functionality works. In order to email contacts from some countries (e.g. Germany) compliantly you are required to gather explicit opt in consent initially (i.e. Dataships widget on your checkout) and also get confirmation via email (i.e. Klaviyo confirmation email).  In order to trigger this confirmation email your Klaviyo list must be double opt-in enabled. Klaviyo only allows a list to be single opt-in enabled or double opt-in enabled, therefore two lists are needed to ensure contacts are sent to the correct one depending on their compliance requirement.",
        },
        bothDouble: {
          title:
            "Shouldn't all of my lists be double opt-in enabled to be compliant?",
          content:
            "No, this is not the case. From a compliance perspective most countries do not require you to confirm consent with the contact with a second step (i.e. Klaviyo confirmation email). The majority of contacts we collect and verify for you will be sent to your single opt-in enabled list. This will give you the opportunity to maximize the contacts you can send marketing emails to compliantly.",
        },
        contactsForwarding: {
          title:
            "What types of contacts will be sent to the single opt-in enabled list and the double opt-in list?",
          content: {
            paragraph1:
              "Depending on the email marketing laws and the location of the contact, we will apply the most appropriate and optimal way to gather consent compliantly. There are 5 different standards of consent that the contact, depending on where they are from, need to meet in order for you to compliantly market to them. These are:",
            list1:
              "Explicit consent - via the single opt-in approach (e.g. bulk of ROW)",
            list2:
              "Explicit consent - via the double opt-in approach (e.g. Germany)",
            list3:
              "'Soft opt-in' - via the opt-out method in the context of a sale (e.g. Ireland, UK, Sweden etc.)",
            list4:
              "Implied consent - where an Existing Business Relationship exists (e.g. Canada)",
            list5:
              "No consent required - where contacts are only presented with the required privacy notices (e.g. USA)",
            paragraph2:
              "Contacts that require 'Explicit consent - via the double opt-in approach' will be sent to the double opt-in enabled list and all other types will be sent to the single opt-in enabled list.",
          },
        },
        determineMarketable: {
          title:
            "How does Dataships determine if a contact is marketable or not?",
          content:
            "We take a number of different factors into account to determine the correct marketable status for the contact. It all starts with determining the correct standard of consent needed depending on where the contact is from. We then take into account the contact's consent action during the purchase (e.g. tick box to opt-in). We also take into account other factors such as checking the contact against your exclusion list in Klaviyo or other country specific national opt out lists, checking that your privacy policy was available to the contact at the time, and any other previous marketable or non marketable Dataships statuses if they're a repeat purchaser.",
        },
      },
    },
    right: {
      optInIsNotEnabled:
        "Please complete the steps on the left to enable the button below.",
      optInIsEnabled:
        "Completed successfully! You can now Continue by clicking below",
      errorButton: "Try again",
      continue: "Continue",
      apiKeyError:
        "The API Key you entered is invalid, please click <1>back</1> to return to the previous step and try again.",
      errorBack: "Back",
    },
  },

  shopifyPlacement: {
    left: {
      header: {
        feature: "Step 5",
        heading: "Add the Dataships Consent Collection App to your Checkout",
        description: {
          checkoutExtensibility: {
            openAdminStep: "Go to your <1>Shopify Admin Checkout Settings</1>",
            openCustomiseStepPostWidget:
              "Scroll up to the top and under <1>Checkout customisation</1> click on <3>Customise</3>",
            openCustomiseStep:
              "Under <1>Checkout customisation</1> click on <3>Customise</3>",
            returnSaveStep: "Return to Dataships and click <1>Continue</1>",
            standard: {
              step1:
                "Add the Dataships Extension to your <1>{{page}}</1> page:",
              step1a:
                "Select <1>{{page}}</1> from the drop-down menu in the top center of the page",
              step1b: "Click <1>+ Add app block</1> at the bottom of the page",
              step1c: "Choose <1>Dataships Email Collection</1> in the box that appears",
              step1d:
                "Tick the <1>Include app block in Shop Pay</1> option under <3>Checkout behaviour</3>",
              step1e:
                "To move, drag the icon under the <1>Order details</1>, ensuring it's the first block",
              step1f: "Click <1>Save</1> in the top right hand corner",
            },
            shopifyPlus: {
              step1:
                "Add the Dataships Extension to your <1>Information</1> page",
              step1a: "Click <1>+ Add app block</1> at the bottom of the page",
              step1b: "Choose <1>Dataships Email Collection</1> in the box that appears",
              step1c:
                "Tick the <1>Include app block in Shop Pay</1> option under <3>Checkout behaviour</3>",
              step1d: "Click <1>Save</1> in the top right hand corner",
            },
          },
          widget: {
            step1: "Add the Dataships widget to your <1>Thank You</1> page",
            step2: "Click <1>Copy to Clipboard</1>",
            step3: "Go to your <1>Shopify Admin Checkout Settings</1>",
            step4:
              "Scroll down to <1>Order Status Page</1> and paste the code into the <3>Additional Scripts</3> text box as the first script",
            step5: "Click <1>Save</1>",
          },
        },
      },
    },
    right: {
      cta: "Continue",
    },
  },

  shopifyDisableConsent: {
    left: {
      header: {
        feature: "Step 6",
        heading:
          "Disable your current Shopify Checkout consent collection setting",
        description: {
          step1:
            "Navigate again to your <1>Shopify Admin Checkout Settings</2>",
          step2:
            "Scroll down to <1>Marketing Options</1> and ensure that <3>Email Marketing</3> is <5>unchecked</5>",
          step3:
            "Click <1>Save</1> and return to this screen and click <3>Continue</3>",
        },
      },
    },
    right: {
      continueCta: "Continue",
    },
  },

  shopifyPreview: {
    left: {
      header: {
        feature: "Step 7",
        heading:
          "A preview of how your new Consent Collection Widget will look on your Checkout",
        description:
          "<0><0>Click here:</0> customers will be provided with a pop up message summarizing how their data will be processed.</0><1><0>Privacy Policy:</0> where customers can read more holistically about how their data is processed by your store.</1>",
      },
    },
    right: {
      images: {
        softOptIn: "Soft opt-in consent",
        softOptOut: "Explicit opt-in consent",
        impliedConsent: "Implied consent / No consent required",
      },
      trailingContent: {
        title: "Preview your 'Click here' link",
        description:
          "Click to view the marketing information your customer is presented with.",
        cta: "View",
      },
      modal: {
        title: "Preview of your privacy policy from your widget",
        description:
          'See below for a preview of the information your customer is presented with when they click "Click here" in the widget',
      },
      cta: "Done",
    },
  },

  setupComplete: {
    header: {
      feature: "Setup Complete",
      heading:
        "Congratulations you are now successfully up and running with Dataships!",
      description:
        "Your Checkout is now optimized to compliantly grow your email marketing lists.",
    },
    goHomeButton: "View my Control Panel",
  },
} as const;
